import React, {useMemo, memo} from 'react';
import PropTypes from 'prop-types';
import cl from 'classnames';
import _ from 'lodash';
import {SECTIONS, LANDING_BLOCK_KEYS} from '../../constants/landing';

function LandLink({activeSlide, blocks, language}) {
  const links = useMemo(() => (blocks.filter((b) => (b.enabled))), [blocks]);

  const linksList = useMemo(() => (SECTIONS.map((s) => {
    const enabledLink = _.find(links, {key: s.key});
    if (enabledLink) {
      return s;
    }
    return null;
  }).filter(Boolean)), [links, blocks]);

  return (
    <div className={cl('land-nav blue', {
      hidden: activeSlide === LANDING_BLOCK_KEYS.INTRO,
    })}
    >
      {linksList.map((link) => (
        <a
          key={link.key}
          href={`#${link.key}`}
          className={`land-item ${activeSlide === link.key ? 'active' : ''}`}
        >
          <span
            className="land-link"
            dangerouslySetInnerHTML={{__html: link.adminTitle[language]}}
          />
        </a>
      ))}
    </div>
  );
}

LandLink.defaultProps = {
  language: 'ru',
  activeSlide: '',
  blocks: [],
};

LandLink.propTypes = {
  blocks: PropTypes.arrayOf(PropTypes.shape({})),
  activeSlide: PropTypes.string,
  language: PropTypes.string,
};

export default memo(LandLink);
